(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/slide.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/slide.js');
"use strict";

const _React = React,
  forwardRef = _React.forwardRef;

const Slide = forwardRef((_ref, ref) => {
  let children = _ref.children,
    classNames = _ref.className;
  const className = ['pg_onboardingslides_slide'];
  if (classNames) {
    className.push(classNames);
  }
  return React.createElement("div", {
    className: className.join(' '),
    ref: ref
  }, children);
});
setGlobal('svs.components.onboarding.slides.Slide', Slide);

 })(window);